import * as React from 'react';
import { getLang, translate } from '@js/common/helpers';
import { ShowCard } from './ShowCard';
function isToday(date) {
    var now = new Date();
    return date.getFullYear() === now.getFullYear()
        && date.getMonth() === now.getMonth()
        && date.getDate() === now.getDate();
}
export function DayColumn(_a) {
    var day = _a.day, season = _a.season, type = _a.type, userEmail = _a.userEmail;
    var dayNumber = day.date.getDate();
    var weekday = day.date.toLocaleDateString(getLang(), { weekday: 'short' });
    var month = day.date.toLocaleDateString(getLang(), { month: 'short' });
    return (React.createElement("div", { className: "day-column" },
        React.createElement("div", { className: "day-column-header" },
            React.createElement("span", { className: "day-number" }, dayNumber),
            React.createElement("span", { className: "day-label" },
                weekday,
                " ",
                month),
            isToday(day.date) && React.createElement("span", { className: "day-today-badge" }, translate('calendar.today'))),
        React.createElement("div", { className: "day-column-shows" }, day.events.map(function (event) { return (React.createElement(ShowCard, { key: event.slug, event: event, season: season, type: type, userEmail: userEmail })); }))));
}
